import { render, staticRenderFns } from "./tweet.vue?vue&type=template&id=c322d232&scoped=true&"
import script from "./tweet.vue?vue&type=script&lang=ts&"
export * from "./tweet.vue?vue&type=script&lang=ts&"
import style0 from "./tweet.vue?vue&type=style&index=0&id=c322d232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c322d232",
  null
  
)

export default component.exports